import React from 'react'
import PropTypes from 'prop-types'

import styles from './../style/Cards1.module.scss'

import { Container, Image } from 'react-bootstrap'

import WhiteBlockTitle from './WhiteBlockTitle'
import GreenButton from './GreenButton'
import FeedbackForm from './FeedbackForm'

class Ruchkibezopasnost extends React.Component {
  
  constructor(props) {
    super(props)

    this.state = {
      show_feedback: false
    }
  }

  showFeedback = () => {
    this.setState({ show_feedback: true });
  }
  closeFeedback = () => {
    this.setState({ show_feedback: false });
  }

  formatSlideNumber = (index) => {
    // Добавляем ведущий ноль для чисел меньше 10
    return `[${index < 9 ? '0' + (index + 1) : index + 1}]`
  }

  render() {

    const { list, image, title, rtext, icon, btn, className } = this.props,
    { show_feedback } = this.state

    return (
      <section className={`${styles.section} ${styles[className]}`}>
        <Container>
          {title != `` &&
            <WhiteBlockTitle
              title={title}
              text={rtext}
              className={styles.title}
            />
          }
          <div className={`${styles.list} ${styles[`grid-ruchki`]}`}>
            {list.map( ( elm, k ) => {
              return (
                <div className={`${styles.block} ${styles[k > 0 ? `bg-2` : `bg-1`]}`}>
                  {icon &&
                    <div className={styles.b_icon}>
                      <Image src={elm?.icon} width={21} height={21} alt={`и-${k}`} />
                    </div>
                  }
                  <div className={styles.b_title}>
                    <div className={styles.b_title_t} dangerouslySetInnerHTML={{__html: elm?.name}} />
                    <div>{this.formatSlideNumber(k)}</div>
                  </div>
                  <div className={styles.b_text} dangerouslySetInnerHTML={{__html: elm?.text}} />
                  {btn &&
                    <GreenButton
                      text={`Купить ручку с ключем`}
                      width={0}
                      action={() => this.showFeedback()}
                      className={styles.btn_fullwidth}
                    />
                  }
                </div>
              )
            })}
            {image != `` &&
              <Image src={image} width={307} height={210} alt={`Купить ручку`} style={{ height: `auto` }} />
            }
          </div>
        </Container>
        <FeedbackForm
          title={`Купить ручку с ключем`}
          text={`Свяжитесь с нами и мы оперативно проконсультируем вас`}
          btn={`Отправить`}
          data={[]}
          show={show_feedback}
          handleClose={() => this.closeFeedback()}
        />
      </section>
    )
  }
}

Ruchkibezopasnost.propTypes = {
  list: PropTypes.array,
  image: PropTypes.string,
  title: PropTypes.string,
  rtext: PropTypes.string,
  icon: PropTypes.bool,
  btn: PropTypes.bool,
  className: PropTypes.string
}

Ruchkibezopasnost.defaultProps = {
  list: [],
  image: ``,
  title: ``,
  rtext: ``,
  icon: false,
  btn: true,
  className: `none`
}

export default Ruchkibezopasnost